import { render } from "./FreeTrialList.vue?vue&type=template&id=20fc899e"
import script from "./FreeTrialList.vue?vue&type=script&lang=js"
export * from "./FreeTrialList.vue?vue&type=script&lang=js"

import "./FreeTrialList.vue?vue&type=style&index=0&id=20fc899e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__